<template>
  <!-- <div v-if="parseInt(record.payment_type) === 2" class='col-lg-4 col-sm-4' style="padding: 0px"> -->
    <div class="chat-panel panel panel-default"  style="height:430px; overflow-y:auto;">
      <div class="panel-heading" style="padding: 5px; text-align: right">
        <i class="fa fa-credit-card"></i> الأقساط
        <div class="pull-left">
          <div class="btn-group">
              <button type="button" class="btn btn-default btn-xs dropdown-toggle" data-toggle="dropdown">
                  الاجراء
                  <span class="caret"></span>
              </button>
              <ul class="dropdown-menu pull-left" role="menu">

                  <li>
                      <a href="#" @click="generateInstallments()">
                          <i class="fa fa-magic"></i> توزيع تلقائى
                      </a>
                  </li>

                  <li :class="{ disabled: !(installmentsDiff > 0 && $per.value.createInstallments) }">
                      <a href="#"
                         @click.prevent="(installmentsDiff > 0 && $per.value.createInstallments) && OpenAddModal()">
                          <i class="fa fa-plus-circle"></i> إضافة قسط
                      </a>
                  </li>

                  <li :class="{ disabled: !(installments.length > 0 && $per.value.createInstallments)}">
                      <a href="#"
                         @click.prevent="(installments.length > 0 && $per.value.createInstallments) && ChangeDayModal()">
                          <i class="fa fa-calendar"></i> تعديل يوم السداد
                      </a>
                  </li>

                  <li class="divider"></li>

                  <li :class="{ disabled: !($per.value.deleteAllInstallments) }">
                      <a href="#"
                         @click.prevent="($per.value.deleteAllInstallments) && deleteAllInstallment()">
                          <i class="fa fa-trash"></i> حذف الأقساط
                      </a>
                  </li>

              </ul>
            </div>
      </div>
      </div>
      <div class="panel-body" style="height:365px; overflow-y:auto;padding: 5px">
        <table class="compact-table">
          <thead>
            <tr>
              <th>م</th>
              <th>المبلغ</th>
              <th>التاريخ</th>
              <th>المسدد</th>
              <th>الاجراء</th>
              <th v-if="$per.value.InstallmentPaymrnt_show && hasSavedInstallments">سداد</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in visibleInstallments" v-bind:key="item.uid">
              <td>{{index + 1}}</td>
              <td>{{item.amount}}</td>
              <td>{{item.due_date}}</td>
              <td>{{item.paid}}</td>
              <td><i v-if="item.amount - item.paid > 0 && $per.value.editInstallmentPaymrnt" class="fa fa-pencil" style="color: blue;"  @click="OpenAddModal(item.uid)"></i>&nbsp;&nbsp;&nbsp;<i v-if="item.paid == 0 && $per.value.deleteInstallmentPaymrnt" class="fa fa-trash-o" style="color: red;" @click="deleteInstallment(item.uid)"></i></td>
              <td v-if="$per.value.InstallmentPaymrnt_show && item.state !== 'new'">
                <i class="fa fa-money" style="color: green;" @click="openInstallmentPayModal(item)"></i>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div
      class="panel-footer"
      style="padding: 5px; text-align: center"
      :class="{
        'text-red': installmentsDiff !== 0,
        'text-green': installmentsDiff === 0
        }"
        >
        فرق مبلغ الأقساط = {{ installmentsDiff }}
      </div>
      <!-- ======================= Add Modale Start -->
      <AddInstallmentModal
        :visible="showAddModal"
        :record="installmentRecord"
        :installments="installmentsDraft"
        :ar="ar"
        :customFormatter="customFormatter"
        @close="showAddModal = false"
        @save="saveInstallmentData"
      />
      <!-- ======================= Add Modale End -->
      <!-- ======================= installment pay Modale Start -->
      <installment-pay-modal
        v-if="showInstallmentPayModal"
        :installment="selectedInstallment"
        :technicals="technicals"
        :treasuries="treasuries"
        :ar="ar"
        :customFormatter="customFormatter"
        @close="onInstallmentPayModalClose"
      />
      <!-- ======================= installment pay Modale End -->
      <!-- ======================= Change Day Modale Start -->
      <div v-if="showChangeDayModal" class="custom-centered-modal">
        <div class="modal-dialog modal-sm modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" @click="showChangeDayModal = false">&times;</button>
              <h4 class="modal-title text-center">تغيير يوم السداد الشهرى</h4>
            </div>

            <div class="modal-body text-center">
              <label>تاريخ أول قسط غير مسدد:</label>
              <div style="padding: 0px 30px;">
              <Datepicker :typeable="true" :format="customFormatter" :language="ar" :bootstrap-styling="true" v-model='paymentDay'></Datepicker>
              </div>
            </div>

            <div class="modal-footer">
              <button @click='saveChangeDay()'  type='button' class='btn btn-outline btn-sm btn-success'> <i class="fa fa-keyboard-o"></i> <b>حفظ</b> </button>
              <button @click="showChangeDayModal = false" type='button' class='btn btn-outline btn-sm btn-default'>إغلاق</button>
            </div>
          </div>
        </div>
      </div>
      <!-- ======================= Change Day Modale End -->
    </div>
  <!-- </div> -->
</template>

<script>
import Swal from 'sweetalert2'
import Datepicker from 'vuejs-datepicker'
import {ar} from 'vuejs-datepicker/dist/locale'
import moment from 'moment'
import AddInstallmentModal from './AddInstallmentModal.vue'
import InstallmentPayModal from './InstallmentPayModal.vue'
export default {
  name: 'InstallmentsModal',
  // *********************************************
  components: {
    Datepicker,
    InstallmentPayModal,
    AddInstallmentModal
  },
  // *********************************************
  computed: {
    totalInstallments () {
      return this.installmentsDraft
        .filter(i => i.state !== 'deleted')
        .reduce((s, i) => s + Number(i.amount), 0)
    },
    installmentsDiff () {
      return Number(this.rest || 0) - this.totalInstallments
    },
    visibleInstallments () {
      return this.installmentsDraft.filter(i => i.state !== 'deleted')
    },
    hasSavedInstallments () {
      return this.visibleInstallments.some(i => i.state !== 'new')
    }
  },
  // *********************************************
  watch: {
    installments: {
      handler (newVal) {
        this.installmentsDraft = JSON.parse(JSON.stringify(newVal))
      },
      immediate: true
    }
  },
  // *********************************************
  props: {
    rest: Number,
    instalCount: Number,
    instalAmount: Number,
    instalStart: {
      type: [String, Date],
      default: null
    },
    installments: {
      type: Array,
      default: () => []
    },
    treasuries: {
      type: Array,
      required: true
    },
    technicals: {
      type: Array,
      required: true
    }
  },
  // *********************************************
  data () {
    return {
      showChangeDayModal: false,
      installmentsDraft: [],
      ar: ar,
      installmentRec: null,
      rerurnedRecords: [],
      showInstallmentPayModal: false,
      selectedSubrec: null,
      showAddModal: false,
      installmentRecord: {
        id: -1,
        amount: '',
        due_date: '',
        paid: ''
      }
    }
  },
  // *********************************************
  created () {
    let installmentRec = {}
    if (this.installments.length > 0) {
      installmentRec = JSON.parse(JSON.stringify(this.installments[0]))
    }
    if ((Number(installmentRec.paid) || 0) === 0) {
      installmentRec.type = 1
    } else {
      if ((Number(installmentRec.paid) || 0) === (Number(installmentRec.amount) || 0)) {
        installmentRec.pay = installmentRec.paid
        installmentRec.paid = 0
        installmentRec.type = 2
      } else {
        installmentRec.type = 3
      }
    }
    this.installmentRec = installmentRec
    // this.remainingAmount()
    // this.focusPayInput()
  },
  // *********************************************
  methods: {
    customFormatter (date) {
      return moment(date).format('YYYY-MM-DD')
    },
    // =====================================================
    // focusPayInput () {
    //   this.$nextTick(() => {
    //     if (this.$refs.payInput) {
    //       this.$refs.payInput.focus()
    //       this.$refs.payInput.select()
    //     }
    //   })
    // },
    // ==================================================
    onInstallmentModalClose (result) {
      this.showInstallmentPayModal = false
    },
    // ==================================================
    closeModal () {
      console.log('closeModal')
      this.$emit('close', {
        rerurnedRecords: this.rerurnedRecords
      })
    },
    // ==================================================
    // remainingAmount () {
    //   this.installmentRec.Remaining =
    //     Number(this.installmentRec.amount || 0) - Number(this.installmentRec.paid || 0) - Number(this.installmentRec.pay || 0)
    // },
    // ==================================================
    isNumber (evt) {
      const c = evt.which ? evt.which : evt.keyCode
      if ((c > 31 && (c < 48 || c > 57)) && c !== 46) {
        evt.preventDefault()
      }
    },
    /*
|--------------------------------------------------------------------------
| *** prepare Installments to return data ***********
|--------------------------------------------------------------------------
*/
    prepareInstallmentsPayload () {
      console.log(this.installmentsDraft)
      const newInstallments = []
      const updatedInstallments = []
      const deletedInstallments = []
      this.installmentsDraft.forEach(inst => {
        if (inst.state === 'new') {
          newInstallments.push({
            uid: inst.uid,
            amount: Number(inst.amount),
            due_date: inst.due_date
          })
        }
        if (inst.state === 'updated') {
          updatedInstallments.push({
            uid: inst.uid,
            amount: Number(inst.amount),
            due_date: inst.due_date
          })
        }
        if (inst.state === 'deleted') {
          deletedInstallments.push({
            uid: inst.uid
          })
        }
      })
      return {
        newInstallments,
        updatedInstallments,
        deletedInstallments
      }
    },
    /*
|--------------------------------------------------------------------------
| *** Installment Pay Modal ***********
|--------------------------------------------------------------------------
*/
    openInstallmentPayModal (rec) {
      if (this.installmentsDraft.id === 0 || this.installmentsDraft.id === null) {
        return
      }
      this.selectedInstallment = rec
      this.showInstallmentPayModal = true
    },
    // =====================================================
    onInstallmentPayModalClose (result) {
      this.showInstallmentPayModal = false
      if (
        result.rerurnedRecords &&
        result.rerurnedRecords.installments &&
        result.rerurnedRecords.installments.length > 0
      ) {
        this.installmentsDraft = result.rerurnedRecords.installments
        this.$emit('return-data', result.rerurnedRecords.balance, result.rerurnedRecords.customerId)
      }
    },
    /*
|--------------------------------------------------------------------------
| *** Auto Generate Installment ***********
|--------------------------------------------------------------------------
*/
    generateInstallments () {
      let txtMsg = ''
      if (this.instalAmount < 1) {
        txtMsg = 'قم بتحديد قيمة القسط'
      }
      if (!this.instalCount) {
        txtMsg = 'قم باختيار عدد الأقساط'
      }
      if (!this.instalStart) {
        txtMsg = 'قم بتحديد تاريخ أول قسط'
      }
      if (this.installmentsDraft.some(i => i.state !== 'deleted')) {
        txtMsg = 'قم بإفراغ جميع الأقساط أولاً'
      }
      if (txtMsg !== '') {
        Swal.fire({
          icon: 'warning',
          title: 'تنبيه',
          text: txtMsg,
          confirmButtonText: 'موافق',
          confirmButtonColor: '#e74c3c',
          allowOutsideClick: false
        })
        return
      }
      const totalAmount = Number(this.rest)
      const instalCount = Number(this.instalCount)
      let instalAmount = Number(this.instalAmount)
      const baseDate = moment(this.instalStart, 'YYYY-MM-DD')
      let usedAmount = 0
      for (let i = 0; i < instalCount; i++) {
        if (usedAmount >= totalAmount) break
        let amount = instalAmount
        if (usedAmount + amount > totalAmount) {
          amount = totalAmount - usedAmount
        }
        if (amount <= 0) break
        const due = baseDate.clone().add(i, 'months')
        this.installmentsDraft.push({
          uid: 'tmp_' + Date.now() + '_' + i,
          amount: Number(amount.toFixed(2)),
          due_date: due.format('YYYY-MM-DD'),
          paid: 0,
          state: 'new',
          sub_payments: []
        })
        usedAmount += amount
      }
      const totalInstalls = this.installmentsDraft
        .filter(i => i.state !== 'deleted')
        .reduce((sum, i) => sum + Number(i.amount), 0)

      const diff = Number((totalAmount - totalInstalls).toFixed(2))
      if (diff !== 0 && this.installmentsDraft.length > 0) {
        const last = this.installmentsDraft[this.installmentsDraft.length - 1]
        last.amount = Number((last.amount + diff).toFixed(2))
      }
    },
    /*
|--------------------------------------------------------------------------
| *** delete single Installment ***********
|--------------------------------------------------------------------------
*/
    deleteInstallment (uid) {
      const rec = this.installmentsDraft.find(i => i.uid === uid)
      if (!rec) return
      Swal.fire({
        title: 'هل أنت متأكد',
        text: 'سيتم حذف هذا القسط',
        icon: 'warning',
        showCancelButton: true,
        cancelButtonColor: '#3085d6',
        confirmButtonColor: '#d33',
        cancelButtonText: 'لا',
        confirmButtonText: 'نعم'
      }).then((result) => {
        if (!result.isConfirmed) return
        // لو القسط جديد
        if (rec.state === 'new') {
          this.installmentsDraft =
            this.installmentsDraft.filter(i => i.uid !== uid)
        } else {
          // لو قسط قديم
          rec.state = 'deleted'
        }
        Swal.fire({
          position: 'fixed',
          icon: 'success',
          title: 'تم الحذف بنجاح',
          showConfirmButton: false,
          timer: 1000
        })
      })
    },
    /*
|--------------------------------------------------------------------------
| *** delete All Installments ***********
|--------------------------------------------------------------------------
*/
    async deleteAllInstallment () {
      // الأقساط اللي ينفع تتحذف
      const deletable = this.installmentsDraft.filter(
        i => Number(i.paid || 0) === 0 && i.state !== 'deleted'
      )
      if (deletable.length === 0) {
        Swal.fire({
          icon: 'info',
          title: 'لا يوجد أقساط يمكن حذفها',
          text: 'كل الأقساط بها عمليات سداد',
          confirmButtonText: 'حسناً'
        })
        return
      }
      const result = await Swal.fire({
        title: 'هل أنت متأكد',
        text: 'سيتم حذف جميع الأقساط غير المسددة',
        icon: 'warning',
        showCancelButton: true,
        cancelButtonColor: '#3085d6',
        confirmButtonColor: '#d33',
        cancelButtonText: 'لا',
        confirmButtonText: 'نعم'
      })
      if (!result.isConfirmed) return

      deletable.forEach(rec => {
        // لو القسط جديد
        if (rec.state === 'new') {
          const i = this.installmentsDraft.indexOf(rec)
          if (i > -1) this.installmentsDraft.splice(i, 1)
        } else {
          // قسط قديم
          rec.state = 'deleted'
        }
      })
      console.log(this.installmentsDraft)
      Swal.fire({
        position: 'fixed',
        icon: 'success',
        title: 'تم حذف الأقساط غير المسددة',
        showConfirmButton: false,
        timer: 1200
      })
    },
    /*
    |--------------------------------------------------------------------------
    | *** Add Eddit Installments ***********
    |--------------------------------------------------------------------------
    */
    OpenAddModal (uid) {
      // إضافة قسط جديد
      if (!uid) {
        this.installmentRecord = {
          uid: null,
          due_date: '',
          amount: '',
          paid: 0
        }
      } else {
        // تعديل قسط
        const rec = this.installmentsDraft.find(i => i.uid === uid)
        if (!rec) return
        this.installmentRecord = {
          uid: rec.uid,
          due_date: rec.due_date,
          amount: rec.amount,
          paid: rec.paid
        }
      }
      this.showAddModal = true
    },
    // ============================================================
    saveInstallmentData (data) {
      // ==============================
      // إضافة قسط جديد
      // ==============================
      if (!data.uid) {
        this.installmentsDraft.push({
          uid: 'tmp_' + Date.now(),
          amount: data.amount,
          paid: 0,
          due_date: data.due_date,
          state: 'new',
          sub_payments: []
        })
      } else {
        // ==============================
        // تعديل قسط
        // ==============================
        const rec = this.installmentsDraft.find(i => i.uid === data.uid)
        if (!rec) return
        rec.amount = data.amount
        rec.due_date = data.due_date

        if (rec.state === 'clean') {
          rec.state = 'updated'
        }
      }
      // ترتيب الأقساط
      this.installmentsDraft.sort((a, b) =>
        moment(a.due_date).diff(moment(b.due_date))
      )
    },
    /*
    |--------------------------------------------------------------------------
    | *** change Installments Payment Date ***********
    |--------------------------------------------------------------------------
    */
    ChangeDayModal () {
      this.paymentDay = null
      this.showChangeDayModal = true
    },
    // ============================================================
    saveChangeDay () {
      const baseDate = moment(this.paymentDay, 'YYYY-MM-DD', true)
      if (!baseDate.isValid()) return
      // تواريخ الأقساط المدفوعة
      const lockedDates = this.installmentsDraft
        .filter(i => Number(i.paid) > 0)
        .map(i => i.due_date)
      let counter = 0
      this.installmentsDraft.forEach(inst => {
        if (inst.state === 'deleted') return
        if (Number(inst.paid) === 0) {
          let newDate
          do {
            newDate = baseDate.clone().add(counter, 'months')
            const day = baseDate.date()
            const lastDay = newDate.clone().endOf('month').date()
            newDate.date(Math.min(day, lastDay))
            counter++
          } while (lockedDates.includes(newDate.format('YYYY-MM-DD')))
          inst.due_date = newDate.format('YYYY-MM-DD')
          if (inst.state === 'clean') {
            inst.state = 'updated'
          }
        }
      })
      this.showChangeDayModal = false
    }
    // ============================================================
  }
}
</script>
<style>
.highlight {
   background-color: #5A9EF5;
}
tr:hover{
   cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Sales/Customers/contractModale/InstallmentsModal.vue